export const CSP_CAMPAIGNS_PATH = '/csp-campaigns';
export const DECLINED_CSP_CAMPAIGNS_PATH = `${CSP_CAMPAIGNS_PATH}/declined`;
export const CSP_CAMPAIGN_DETAILS_PATH = `${CSP_CAMPAIGNS_PATH}/:id`;
export const LEGACY_CSP_CAMPAIGNS_PATH = '/campaigns';
export const LEGACY_CSP_CAMPAIGN_DETAILS_PATH = `${LEGACY_CSP_CAMPAIGNS_PATH}/:id`;
export const RCS_CSP_CAMPAIGNS_PATH = '/rcs-csp-campaigns';
export const RCS_DCA_CAMPAIGNS_PATH = '/rcs-dca-campaigns';

export const DCA_CAMPAIGNS_PATH = '/dca-campaigns';
export const DECLINED_DCA_CAMPAIGNS_PATH = `${DCA_CAMPAIGNS_PATH}/declined`;
export const DCA_CAMPAIGN_DETAILS_PATH = `${DCA_CAMPAIGNS_PATH}/:id`;

export const CSP_CAMPAIGNS_DEFAULT_ENTRY = `${CSP_CAMPAIGNS_PATH}?status=ACTIVE&provisional=false`;
export const DCA_CAMPAIGNS_DEFAULT_ENTRY = `${DCA_CAMPAIGNS_PATH}?status=ACTIVE&provisional=false`;

export const RCS_CSP_CAMPAIGN_DETAILS_PATH = `${RCS_CSP_CAMPAIGNS_PATH}/:id`;
export const RCS_DCA_CAMPAIGN_DETAILS_PATH = `${RCS_DCA_CAMPAIGNS_PATH}/:id`;
export const RCS_CSP_CAMPAIGNS_DEFAULT_ENTRY = `${RCS_CSP_CAMPAIGNS_PATH}?status=ACTIVE`;
export const RCS_DCA_CAMPAIGNS_DEFAULT_ENTRY = `${RCS_DCA_CAMPAIGNS_PATH}?status=ACTIVE`;

export const WILDCARD_CAMPAIGN_DETAILS_PATH = '/wildcard-campaigns/:id';

export const NUMBER_HISTORY_PATH = '/phones/:phone';
